import React from "react";
import { Card, Dropdown, Button, Spinner } from "react-bootstrap";
import { store } from "../../../reducer/Store";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import ModalFormRegisterOrUpdate from "../../../components/ModalFormRegisterOrUpdate";
import ApiService from "../../../services/ApiService";

const CoordonneesAmbassadrice = ({ refreshTab }) => {
  const { dispatch, state } = React.useContext(store);
  const [showUpdateAmb, setShowUpdateAmb] = React.useState(false);
  const [showRegisterAmb, setShowRegisterAmb] = React.useState(false);
  const [lastname, setLastname] = React.useState("");
  const [firstname, setFirstname] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [ambassadriceId, setAmbassadriceId] = React.useState("");

  const handleClose = () => {
    setShowUpdateAmb(false);
    setShowRegisterAmb(false);
    setLastname("");
    setEmail("");
    setFirstname("");
    setAmbassadriceId("");
  };

  /**
   * Cette fonction met à jour les informations d'une ambassadrice.
   * @param { Object } ambassadrice - L'objet contenant les informations de l'ambassadrice à mettre à jour.
   */
  const handleUpdateAmb = (ambassadrice) => {
    setFirstname(ambassadrice.firstname);
    setLastname(ambassadrice.lastname);
    setEmail(ambassadrice.email);
    setAmbassadriceId(ambassadrice.id);
    setShowUpdateAmb(true);
  };

  const handleRegisterAmb = () => setShowRegisterAmb(true);

  /**
   * Cette fonction récupère la liste des ambassadrices pour un client spécifique et une année donnée.
   */
  const getAmbassadrices = async () => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {},
      `interlocutors-ambassadors-by-customer-year/${state.dataSelectedClient.id}/${state.currentYear.value}`,
      "get"
    )
      .then(function (response) {
        dispatch({
          type: "SET_LISTAMBASSADRICES",
          payload: response.data,
        });
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error.response.data.message);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction met à jour les informations d'une ambassadrice.
   * @param { String } lastname - Le nom de famille de l'ambassadrice.
   * @param { String } firstname - Le prénom de l'ambassadrice.
   * @param { String } email - L'adresse e-mail de l'ambassadrice.
   * @param { String } phoneNbr - Le numéro de téléphone de l'ambassadrice.
   * @param { Number } ambassadriceId - L'identifiant de l'ambassadrice à mettre à jour.
   * @param { Number } year_id - L'année à laquelle se rattacher.
   * @param { Number } interlocutor_role_id - Le rôle de l'ambassadrice.
   * @param { Number } state.dataSelectedClient.id - Le client sélectionné qui a cette ambassadrice.
   */
  const updateAmbassadrice = () => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {
        lastname: lastname,
        firstname: firstname,
        email: email,
        phone: "",
        year_id: state.currentYear.value,
        customer_id: state.dataSelectedClient.id,
        interlocutor_role_id: 2,
      },
      `interlocutors/${ambassadriceId}`,
      "put"
    )
      .then(function () {
        handleClose();
        getAmbassadrices();
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error.response.data.message);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction enregistre une nouvelle ambassadrice.
   * @param { String } lastname - Le nom de famille de l'ambassadrice.
   * @param { String } firstname - Le prénom de l'ambassadrice.
   * @param { String } email - L'adresse e-mail de l'ambassadrice.
   * @param { String } phoneNbr - Le numéro de téléphone de l'ambassadrice.
   * @param { Number } year_id - L'année à laquelle se rattacher.
   * @param { Number } interlocutor_role_id - Le rôle de l'ambassadrice.
   * @param { Number } state.dataSelectedClient.id - Le client sélectionné qui aura cette ambassadrice.
   */
  const registerAmbassadrice = () => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {
        lastname: lastname,
        firstname: firstname,
        email: email,
        phone: "",
        interlocutor_role_id: 2,
        year_id: state.currentYear.value,
        customer_id: state.dataSelectedClient.id,
      },
      `interlocutors`,
      "post"
    )
      .then(function () {
        handleClose();
        getAmbassadrices();
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error.response.data.message);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction supprime une ambassadrice.
   * @param {Object} ambassadrice - L'objet représentant l'ambassadrice à supprimer.
   */
  const deleteAmbassadrice = (ambassadrice) => {
    if (
      window.confirm(
        "Êtes vous sûr de vouloir supprimer l'ambassadrice " +
          ambassadrice.lastname +
          " " +
          ambassadrice.firstname +
          " ?"
      )
    ) {
      dispatch({ type: "SET_LOADER", payload: true });
      ApiService.request({}, "interlocutors/" + ambassadrice.id, "delete")
        .then(function () {
          dispatch({ type: "SET_LOADER", payload: false });
          getAmbassadrices();
        })
        .catch(function (error) {
          dispatch({ type: "SET_LOADER", payload: false });
          console.log(error);
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
            dispatch({ type: "SET_LOGOUT", payload: false });
          }
        });
    }
  };

  React.useEffect(() => {
    if (state.dataSelectedClient && state.dataSelectedClient.id) {
      getAmbassadrices();
    }
  }, [state.dataSelectedClient, state.currentYear.value, refreshTab]);

  return (
    <>
      {!state.loader ? (
        <div className="row">
          <div className="col-md-6">
            <Card className="bg-green-house mb-3 mb-md-0">
              <Card.Body>
                <Card.Title>Adresse</Card.Title>
                <div className="grey">
                  <Card.Text className="mb-0">
                    {state.dataCustomer.postal_address}
                  </Card.Text>
                  <Card.Text className="mb-0">
                    {state.dataCustomer.postal_code}
                  </Card.Text>
                  <Card.Text className="mb-0">
                    {state.dataCustomer.postal_city}
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-6">
            <Card className="bg-pink-user">
              <Card.Body>
                <Card.Title>Ambassadrices</Card.Title>
                {state.listAmbassadrices.map((elt, key) => (
                  <div key={key}>
                    <div className="row align-items-center grey">
                      <div className="col-md-10">
                        <Card.Text className="mb-0">
                          {elt.lastname} {elt.firstname}
                        </Card.Text>
                        <Card.Text className="mb-2">{elt.email}</Card.Text>
                      </div>
                      {(parseInt(localStorage.getItem("user_role")) !== 5 &&
                        parseInt(localStorage.getItem("user_role")) !== 6) && (
                        <div className="col-md-2">
                          <Dropdown className="d-flex justify-content-end">
                            <Dropdown.Toggle>
                              <MoreVertIcon />
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => handleUpdateAmb(elt)}
                              >
                                <EditOutlinedIcon className="grey" /> Modifier
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => deleteAmbassadrice(elt)}
                              >
                                <DeleteOutlinedIcon className="red" /> Supprimer
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      )}
                    </div>
                    <hr />
                  </div>
                ))}
                {(parseInt(localStorage.getItem("user_role")) !== 5 &&
                  parseInt(localStorage.getItem("user_role")) !== 6) && (
                  <Button
                    onClick={() => {
                      handleRegisterAmb();
                    }}
                    className="button-add is-bottom-right"
                  >
                    Ajouter Ambassadrice
                  </Button>
                )}
              </Card.Body>
            </Card>
          </div>
        </div>
      ) : (
        <div className="text-center pt-5">
          <Spinner
            animation={state.loader ? "border" : false}
            role="status"
          ></Spinner>
        </div>
      )}
      {showUpdateAmb && (
        <ModalFormRegisterOrUpdate
          show={showUpdateAmb}
          registerOrUpdate={updateAmbassadrice}
          name={firstname}
          lastname={lastname}
          email={email}
          setEmail={setEmail}
          setName={setFirstname}
          setLastname={setLastname}
          handleClose={handleClose}
          controlFormId={"update-ambassadrice"}
        />
      )}

      {showRegisterAmb && (
        <ModalFormRegisterOrUpdate
          show={showRegisterAmb}
          registerOrUpdate={registerAmbassadrice}
          name={firstname}
          lastname={lastname}
          email={email}
          setEmail={setEmail}
          setName={setFirstname}
          setLastname={setLastname}
          handleClose={handleClose}
          controlFormId={"register-ambassadrice"}
        />
      )}
    </>
  );
};

export default CoordonneesAmbassadrice;
